/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProductCategory,
    ProductCategoryFromJSON,
    ProductCategoryFromJSONTyped,
    ProductCategoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetProductCategoryResponse
 */
export interface GetProductCategoryResponse {
    /**
     * 
     * @type {ProductCategory}
     * @memberof GetProductCategoryResponse
     */
    product?: ProductCategory;
}

export function GetProductCategoryResponseFromJSON(json: any): GetProductCategoryResponse {
    return GetProductCategoryResponseFromJSONTyped(json, false);
}

export function GetProductCategoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProductCategoryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product': !exists(json, 'product') ? undefined : ProductCategoryFromJSON(json['product']),
    };
}

export function GetProductCategoryResponseToJSON(value?: GetProductCategoryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product': ProductCategoryToJSON(value.product),
    };
}


